import { api } from '../rtk';
import { ENDPOINTS } from '../url';

export const authApi = api.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (credentials) => ({
                url: ENDPOINTS.LOGIN,
                method: 'POST',
                body: credentials,
            }),
        }),
        sendOtp: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.SEND_OTP,
                method: 'POST',
                body: data,
            }),
        }),
        verifyOtp: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.VERIFY_OTP,
                method: 'POST',
                body: data,
            }),
        }),
        changePassword: builder.mutation({
            query: ({ data, token }) => ({
                url: ENDPOINTS.CHANGE_PASSWORD,
                method: 'POST',
                body: data,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }),
        }),
        updatePasswordInsidePanel: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.CHANGE_PASSWORD,
                method: 'POST',
                body: data,
            }),
        }),
        getProfile: builder.query({
            query: () => ({
                url: ENDPOINTS.PROFILE,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        updateProfile: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.UPDATE_PROFILE,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['User'],
        }),
        logout: builder.mutation({
            query: () => ({
                url: ENDPOINTS.LOGOUT,
                method: 'GET',
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useLoginMutation,
    useSendOtpMutation,
    useVerifyOtpMutation,
    useChangePasswordMutation,
    useUpdatePasswordInsidePanelMutation,
    useGetProfileQuery,
    useUpdateProfileMutation,
    useLogoutMutation } = authApi;
